import { BaseWorkflowPanel } from "./BaseWorkflowPanel";
import { BoundaryBox } from "../BoundingBoxEditor";

interface WorkflowProps {
  device: any;
  deviceId: string;
  questionValue: string;
  onQuestionChange: (v: string) => void;
  onSaveQuery: () => void;
  onGenerateQuery: () => void;
  onSaveBoundingBoxes: (boxes: BoundaryBox[]) => Promise<void>;
  isUpdating: boolean;
  canEdit: boolean;
  notification: { result: string; reason: string; message: string; subject: string };
  updateField?: (field: string, value: string | number) => Promise<void>;
  aiWorkflow?: string;
}

export const ChangeDetectionWorkflow = (props: WorkflowProps) => <BaseWorkflowPanel {...props} hideROI />;
